import style from './style.module.scss';

/**
 * Simple loading screen shown during initial app startup
 * (before translations/config are loaded)
 */
function InitialLoader() {
	return (
		<main className={style.main}>
			<div className={style.spinner} />
		</main>
	);
}

export default InitialLoader;
